module.exports = __webpack_public_path__ + "img/tank-follow.a66c735a.jpg";